module.exports = flarum.reg.get('core', 'common/app');